module.exports = __webpack_public_path__ + "static/media/icon-score-3-scale-4.a918b0b8.svg";